import { render } from "./EndGame.vue?vue&type=template&id=2bdef310"
import script from "./EndGame.vue?vue&type=script&lang=js"
export * from "./EndGame.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__